import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="total-count"
export default class extends Controller {
  static targets = [ "countField", "result" ]

  initialize() {
    this.changeResultHtml()
  }

  calculateTotal() {
    let total = 0
    this.countFieldTargets.forEach(element => total += Number(element.value))
    return total
  }

  changeResultHtml() {
    this.resultTarget.innerHTML = this.calculateTotal()
  }
}
